import React, { ReactNode } from 'react';
import {
  FormInput,
  Label,
  IFormInputProps,
  NumericFormatInputProps,
  NumericFormatInput,
} from '@grubhubprod/gh-cookbook-react';
import { Control, RegisterOptions, useController } from 'react-hook-form';

interface CookbookNumericFormatInputWrapper {
  name: string;
  control: Control;
  rules?: RegisterOptions;
  error?: IFormInputProps['error'];
  label?: ReactNode;
}

export type CookbookNumericFormatInputWrapperProps =
  CookbookNumericFormatInputWrapper & NumericFormatInputProps;

export function CookbookNumericFormatInputWrapper({
  name,
  control,
  rules = {},
  error,
  label = '',
  ...cookbookNumericFormatInput
}: CookbookNumericFormatInputWrapperProps): JSX.Element {
  const {
    field: { ref, value, onBlur, onChange },
  } = useController({
    name,
    rules,
    control,
    defaultValue: control.defaultValuesRef.current[name] ?? '',
  });
  return (
    <FormInput
      error={error}
      inputSize={cookbookNumericFormatInput.inputSize}
      blockWidth={cookbookNumericFormatInput.blockWidth}
    >
      {label && <Label htmlFor={cookbookNumericFormatInput.id}>{label}</Label>}
      <NumericFormatInput
        {...cookbookNumericFormatInput}
        inputRef={ref}
        value={value}
        onValueChange={(v: string | number): void => onChange(v ?? '')}
        onBlur={onBlur}
      />
    </FormInput>
  );
}
